<template>
    <div class="main">
        <c-panel title="EVOLUÇÃO INDIVIDUAL DO ALUNO" titleIcon="fas fa-chart-line">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Visualização">
                            <el-select v-model="dimensao" @change="recarregar" placeholder="Selecione a visualização" style="width:100%;">
                                <el-option label="Notas" value="notas"></el-option>
                                <el-option label="Frequência" value="frequencia"></el-option>
                                <el-option label="Tab. BASE" value="tabBase"></el-option>
                                <el-option label="Tab. DESENHO" value="tabDesenho"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Aluno">
                            <el-select v-model="alunoId" filterable remote :remote-method="buscarAluno" :loading="loadAluno"
                                placeholder="Digite o nome..." style="width:100%;" @change="onAlunoChange">
                                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="alunoId && dimensao === 'notas'">

                <!-- Avaliação quantitativa (fluxo original, inalterado) -->
                <template v-if="temNotasNumericas">
                    <h3>Média final por período letivo</h3>
                    <bar-chart :chart-data="dadosNotas" :options="opcoesNota" :height="500"></bar-chart>

                    <h4 v-if="dadosNotas.detalhes && dadosNotas.detalhes.length">Detalhes</h4>
                    <table v-if="dadosNotas.detalhes && dadosNotas.detalhes.length" class="table">
                        <thead><tr><th>Período</th><th>Turma</th><th class="u-text-right">Média</th></tr></thead>
                        <tbody>
                            <tr v-for="d in dadosNotas.detalhes" :key="d.periodo_id">
                                <td>{{ d.periodo }} ({{ d.ano }})</td>
                                <td>{{ d.turma || '—' }}</td>
                                <td class="u-text-right"><strong>{{ d.media }}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <!-- Avaliação por conceito (novo) -->
                <template v-if="temConceitos">
                    <div v-for="(p, idx) in dadosConceitos.periodos" :key="idx" style="margin-top:18px;">
                        <h3 style="margin-bottom:6px;">Conceitos — {{ p.periodo_letivo }}
                            <small style="color:#909399; font-weight:normal;">({{ p.turma }})</small>
                        </h3>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Disciplina</th>
                                    <th v-for="col in p.colunas" :key="col.key" class="u-text-center">{{ col.label }}</th>
                                    <th v-if="p.tem_recuperacao" class="u-text-center">Recuperação</th>
                                    <th v-if="p.tem_final" class="u-text-center">Conceito final</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, di) in p.disciplinas" :key="di">
                                    <td>{{ d.disciplina }}</td>
                                    <td v-for="col in p.colunas" :key="col.key" class="u-text-center">{{ d.conceitos[col.key] || '—' }}</td>
                                    <td v-if="p.tem_recuperacao" class="u-text-center">{{ d.conceitos['r'] || '—' }}</td>
                                    <td v-if="p.tem_final" class="u-text-center"><strong>{{ d.conceitos['m_final'] || '—' }}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p v-if="legendaConceito.length" style="color:#909399; font-size:12px; margin-top:6px;">
                        <i class="el-icon-info"></i> Legenda:
                        <span v-for="item in legendaConceito" :key="item.v" style="margin-right:12px;"><strong>{{ item.v }}</strong> = {{ item.l }}</span>
                    </p>
                </template>

                <!-- Sem qualquer dado -->
                <p v-if="!temNotasNumericas && !temConceitos" style="color:#909399;">Sem dados de notas para este aluno.</p>
            </div>

            <div v-if="alunoId && dimensao === 'frequencia'">
                <h3>Faltas registradas por período letivo</h3>
                <bar-chart v-if="dadosFreq.datasets && dadosFreq.datasets[0].data.length" :chart-data="dadosFreq" :options="opcoesFreq" :height="500"></bar-chart>
                <p v-else style="color:#909399;">Sem dados de frequência para este aluno.</p>
                <p v-if="dadosFreq.observacao" style="color:#909399; font-size:12px; margin-top:6pt;">
                    <i class="el-icon-info"></i> {{ dadosFreq.observacao }}
                </p>
            </div>

            <div v-if="alunoId && (dimensao === 'tabBase' || dimensao === 'tabDesenho')">
                <h3>Tabulação — {{ dimensao === 'tabBase' ? 'BASE (escrita)' : 'DESENHO' }}</h3>
                <table v-if="dadosTab.labels && dadosTab.labels.length" class="table">
                    <thead><tr><th>Período diagnóstico</th><th>Nível</th></tr></thead>
                    <tbody>
                        <tr v-for="(l, i) in dadosTab.labels" :key="i">
                            <td>{{ l }}</td>
                            <td><strong>{{ dadosTab.niveis[i] }}</strong></td>
                        </tr>
                    </tbody>
                </table>
                <p v-else style="color:#909399;">Sem lançamentos de tabulação para este aluno.</p>
            </div>

            <p v-if="!alunoId" style="color:#909399; padding:20pt;">Selecione um aluno acima para visualizar a evolução.</p>
        </c-panel>
    </div>
</template>

<script>
import BarChart from '@/chart/BarChart.js'
export default {
    components: { BarChart },
    data () {
        return {
            alunoId: null, alunos: [], loadAluno: false,
            dimensao: 'notas',
            dadosNotas: { datasets: [{ data: [] }] },
            dadosConceitos: { escala: {}, periodos: [] },
            dadosFreq:  { datasets: [{ data: [] }] },
            dadosTab:   { labels: [], niveis: [] },
            // max:10 assume escala 0-10 nas notas; redes que usam 0-100 não precisam de max
            // (o gráfico ajusta automaticamente). Deixar comentado para revisão futura.
            opcoesNota: { responsive: true, maintainAspectRatio: false, scales: { yAxes: [{ ticks: { beginAtZero: true, suggestedMax: 10 } }] } },
            opcoesFreq: { responsive: true, maintainAspectRatio: false, scales: { yAxes: [{ ticks: { beginAtZero: true } }] } }
        }
    },
    computed: {
        temNotasNumericas () {
            return this.dadosNotas.datasets && this.dadosNotas.datasets[0] && this.dadosNotas.datasets[0].data.length > 0
        },
        temConceitos () {
            return this.dadosConceitos.periodos && this.dadosConceitos.periodos.length > 0
        },
        legendaConceito () {
            const e = this.dadosConceitos.escala || {}
            return Object.keys(e).map(v => ({ v, l: e[v] }))
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunos = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunos = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        onAlunoChange () { this.recarregar() },
        recarregar () {
            if (!this.alunoId) return
            if (this.dimensao === 'notas') this.carregarNotas()
            else if (this.dimensao === 'frequencia') this.carregarFreq()
            else if (this.dimensao === 'tabBase') this.carregarTab('BASE')
            else if (this.dimensao === 'tabDesenho') this.carregarTab('DESENHO')
        },
        carregarNotas () {
            // Avaliação quantitativa (fluxo original, inalterado)
            this.$axios.get(`${this.baseUrl()}/api/evolucao-aluno/notas/${this.alunoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.dadosNotas = r.data || { datasets: [{ data: [] }] } })
            // Avaliação por conceito (aditivo)
            this.$axios.get(`${this.baseUrl()}/api/evolucao-aluno/conceitos/${this.alunoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.dadosConceitos = r.data || { escala: {}, periodos: [] } })
                .catch(() => { this.dadosConceitos = { escala: {}, periodos: [] } })
        },
        carregarFreq () {
            this.$axios.get(`${this.baseUrl()}/api/evolucao-aluno/frequencia/${this.alunoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.dadosFreq = r.data || { datasets: [{ data: [] }] } })
        },
        carregarTab (tipo) {
            this.$axios.get(`${this.baseUrl()}/api/evolucao-aluno/tabulacao/${this.alunoId}/${tipo}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.dadosTab = r.data || { labels: [], niveis: [] } })
        }
    }
}
</script>
